import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { shareReplay, map, filter } from 'rxjs/operators';
import { TextChatsStoreFactoryService } from 'common/text-chats-store-factory/text-chats-store-factory.service';
import { ChatBase } from 'common/xislivechat/models/chat-base';
import { TextChat } from 'common/xislivechat/models/text-chat';
import { ChatsStoreFactoryService } from 'common/chats-store-factory/chats-store-factory.service';
import { EmailsService } from 'common/emails/emails.service';

@Injectable()
export class WorkItemObservableCacheService {
  private readonly observableCache: { [id: string]: Observable<any> };

  constructor(private _chatStore: ChatsStoreFactoryService,
              private _emailService: EmailsService,
              private _textChatsStore: TextChatsStoreFactoryService) {
    this.observableCache = {};
  }

  getWorkItemObservable(workItemId: string, workItemType: string): Observable<any> {
    if (this.observableCache[workItemId]) {
      return this.observableCache[workItemId];
    }
    let observable: Observable<any>;
    switch (workItemType) {
      case WorkItemTypes.CHAT:
        observable = this._chatStore.createForSingleChat(workItemId).pipe(
          filter<ChatBase[]>(array => !!array.length),
          map(WorkItemObservableCacheService.arrayToItemMapper)
        );
        break;
      case WorkItemTypes.EMAIL:
        observable = from(this._emailService.getEmailThread(workItemId));
        break;
      case WorkItemTypes.FACEBOOK:
      case WorkItemTypes.SMS:
      case WorkItemTypes.ASYNC_MESSAGE:
        observable = this._textChatsStore.createForSingleTextChat(workItemId).pipe(
          filter<TextChat[]>(array => !!array.length),
          map(WorkItemObservableCacheService.arrayToItemMapper)
        );
        break;
    }
    const sharedObservable = observable.pipe(
      shareReplay({ bufferSize: 1, refCount: true })
    );
    this.observableCache[workItemId] = sharedObservable;
    return sharedObservable;
  }

  private static arrayToItemMapper(itemArray) {
    if (itemArray.length) {
      return itemArray[0];
    } else {
      return itemArray;
    }
  }
}
